<template>
  <div
    class="account-control"
    :class="{
      'account-control--fade': getShouldFade && !root,
      'account-control--root': root
    }"
  >
    <template v-if="isInit">
      <component
        :is="root ? 'button' : 'div'"
        class="account-control__btn ui-btn"
        :class="{ 'account-control__btn--root': root }"
        @click.stop="handleControlClicked"
        :aria-label="root ? 'Login' : null"
      >
        <AccountIconFilled
          class="account-control__icon"
          v-if="authJWT"
          :style="{ stroke: uiColor, fill: uiColor }"
        />
        <template v-else>
          <Cross
            v-if="active"
            class="account-control__close-icon"
            :style="{ stroke: uiColor }"
          />
          <AccountIcon
            class="account-control__icon"
            :style="{ stroke: uiColor }"
            v-else
          />
        </template>
      </component>
      <span
        class="account-control__name text-body"
        :style="{ color: uiColor }"
        v-if="authJWT && profile && profile.firstName"
      >
        {{ UI_ELEMENT("navigation_greeting") }} {{ profile.firstName }}
      </span>
    </template>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex"
import AccountIcon from "./../../assets/account_icon.svg"
import AccountIconFilled from "./../../assets/account_icon_filled.svg"
import Cross from "@/assets/cross.svg"

export default {
  props: {
    active: Boolean,
    uiColor: String,
    root: Boolean
  },

  data: () => ({
    isInit: false
  }),

  components: {
    AccountIconFilled,
    AccountIcon,
    Cross
  },

  mounted() {
    this.initAccountSession()
  },

  methods: {
    ...mapMutations("ui", ["SET_NAV_ACTIVE_ELEMENT"]),
    ...mapActions("identity", ["currentAuthenticatedUser"]),
    ...mapMutations("identity", ["SET_USERINFO"]),

    async initAccountSession() {
      Bleach.debug.log("initAccountSession - AccountControl")
      // Check if there is an existing authenticated user
      if (!this.authInProgress) {
        await this.currentAuthenticatedUser().catch(() => {
          // If not, then clear out any lingering user data
          this.SET_USERINFO({ user: null })
        })
        this.isInit = true
      } else {
        // wait for result of any authInProgress
        const _unWatch = this.$watch(
          "authInProgress",
          newVal => {
            if (!newVal) {
              _unWatch()
              this.isInit = true
            }
          },
          { immediate: true }
        )
      }
    },

    handleControlClicked() {
      if (this.authJWT) {
        this.$router.push("/account")
      } else {
        this.SET_NAV_ACTIVE_ELEMENT(
          this.navActiveElement === "login" ? null : "login"
        )
      }
    }
  },

  computed: {
    ...mapState("identity", ["authJWT", "authInProgress"]),
    ...mapState("account", ["profile", "getIsUserLoggedIn"]),
    ...mapGetters("breakpoints", ["GET_IS_BELOW_BREAKPOINT"]),
    ...mapState("ui", ["navUiColour", "navActiveElement"]),

    getShouldFade() {
      return (
        /* this.GET_IS_BELOW_BREAKPOINT("md") && */
        this.navActiveElement && this.navActiveElement !== "login"
      )
    }
  }
}
</script>

<style lang="scss">
$stroke-width: 1.5px;

.account-control {
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: auto;
  transition: opacity 0.2s linear;

  &--root {
    * {
      opacity: 0;
    }
  }

  &--fade {
    opacity: 0.1;
  }

  @include media-breakpoint-up(lg) {
    flex-direction: row-reverse;
  }

  &__name {
    display: none;

    @include media-breakpoint-up(lg) {
      display: block;
      width: 220px;
      text-align: left;
      margin-left: 20px;
    }

    @include media-breakpoint-up(lg) {
      text-align: right;
      margin-left: unset;
      margin-right: 20px;
    }
  }

  &__btn {
    position: relative;
    cursor: pointer;
    margin: 0 -8px;
    padding: 0 8px;
    pointer-events: all;

    &--root {
      * {
        opacity: 0;
      }
    }
  }

  &__icon,
  &__close-icon {
    width: 100%;
    height: 22px;
    // stroke: getcolour(bleach_black);

    path {
      stroke: inherit;
      fill: inherit;
      vector-effect: non-scaling-stroke;
      stroke-width: $stroke-width;
    }

    @include media-breakpoint-up(xl) {
      height: 26px;
    }
  }

  &__close-icon {
    transform: scale(0.9);
    transform-origin: center;
  }
}
</style>
